/* ============================================================
   CoolCountry theme — theme.js
   Cart drawer (AJAX), quick-add, variant pickers, accordions,
   marquees, mobile menu, predictive search, sticky ATC.
   ============================================================ */
(function () {
  'use strict';

  var settings = window.themeSettings || {};
  var cartType = settings.cartType || 'drawer';
  var moneyFormat = settings.moneyFormat || '${{amount}}';
  var freeShippingThreshold = parseInt(settings.freeShippingThreshold || '0', 10);

  /* ---------- Motion reveals ----------
     Motion is loaded on demand so the theme remains usable if a CDN is blocked.
  */
  (function initMotion() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealEls = document.querySelectorAll('[data-motion-reveal], [data-motion-stagger] > *');
    if (!revealEls.length || reduced) return;

    import('https://cdn.jsdelivr.net/npm/motion@12.23.12/+esm').then(function (Motion) {
      var inView = Motion.inView;
      var animate = Motion.animate;
      if (!inView || !animate) throw new Error('Motion API unavailable');
      document.documentElement.classList.add('motion-ready');
      document.querySelectorAll('[data-motion-reveal]').forEach(function (el) {
        inView(el, function () {
          var isMedia = el.dataset.motionReveal === 'hero-media';
          animate(el, { opacity: 1, y: 0, scale: 1 }, { duration: isMedia ? 0.8 : 0.65, delay: el.dataset.motionReveal === 'story-copy' ? 0.08 : 0, ease: [0.22, 1, 0.36, 1] });
        }, { amount: 0.01 });
      });
      document.querySelectorAll('[data-motion-stagger]').forEach(function (group) {
        inView(group, function () {
          group.querySelectorAll(':scope > *').forEach(function (el, index) {
            animate(el, { opacity: 1, y: 0 }, { duration: 0.55, delay: index * 0.07, ease: [0.22, 1, 0.36, 1] });
          });
        }, { amount: 0.01 });
      });
    }).catch(function () { document.documentElement.classList.remove('motion-ready'); });
  })();

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (moneyFormat.indexOf('{{amount_no_decimals}}') > -1) {
      return moneyFormat.replace('{{amount_no_decimals}}', Math.round(cents / 100).toString());
    }
    return moneyFormat.replace('{{amount}}', amount);
  }

  /* ---------- Overlay backdrop ---------- */
  var backdrop = document.getElementById('OverlayBackdrop');
  function showBackdrop() { if (backdrop) backdrop.hidden = false; }
  function hideBackdrop() {
    var anyOpen =
      (drawer && !drawer.hidden) ||
      (mobileMenu && !mobileMenu.hidden) ||
      (searchOverlay && !searchOverlay.hidden);
    if (backdrop && !anyOpen) backdrop.hidden = true;
  }
  if (backdrop) {
    backdrop.addEventListener('click', function () {
      closeDrawer(); closeMobileMenu(); closeSearch();
    });
  }

  /* ---------- Quantity steppers (generic) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var stepper = btn.closest('[data-qty]');
    if (!stepper) return;
    var input = stepper.querySelector('[data-qty-input]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10) || 0;
    if (btn.hasAttribute('data-qty-minus')) {
      val = Math.max(min, val - 1);
    } else {
      val = val + 1;
    }
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Accordions ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    acc.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;
      var item = trigger.closest('.accordion__item');
      var panel = item.querySelector('[data-accordion-panel]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      // Close siblings (single-open behavior)
      acc.querySelectorAll('[data-accordion-trigger]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var p = t.closest('.accordion__item').querySelector('[data-accordion-panel]');
        if (p) p.hidden = true;
      });
      if (!isOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) panel.hidden = false;
      }
    });
  });

  /* ---------- Marquee: duplicate groups until the track is wide enough ---------- */
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    var groups = track.querySelectorAll('.announcement-marquee__group, .proof-marquee__group');
    if (!groups.length) return;
    var guard = 0;
    while (track.scrollWidth < window.innerWidth * 2 && guard < 6) {
      groups.forEach(function (g) {
        var clone = g.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      guard++;
    }
  });

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.hidden = false; showBackdrop();
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu || mobileMenu.hidden) return;
    mobileMenu.hidden = true; hideBackdrop();
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-open]')) openMobileMenu();
    if (e.target.closest('[data-mobile-menu-close]')) closeMobileMenu();
    if (mobileMenu && !mobileMenu.hidden && e.target === mobileMenu) closeMobileMenu();
  });

  /* ---------- Search overlay + predictive search ---------- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchTimer = null;

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = false; showBackdrop();
    if (searchInput) searchInput.focus();
  }
  function closeSearch() {
    if (!searchOverlay || searchOverlay.hidden) return;
    searchOverlay.hidden = true; hideBackdrop();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) openSearch();
    if (e.target.closest('[data-search-close]')) closeSearch();
  });
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) {
        if (searchResults) searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () { predictiveSearch(q); }, 280);
    });
  }
  function predictiveSearch(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!searchResults) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          searchResults.innerHTML = '';
          return;
        }
        searchResults.innerHTML = products.map(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
          return (
            '<a class="search-result-row" href="' + p.url + '">' +
            img +
            '<p class="search-result-row__title">' + p.title + '</p>' +
            '<span class="search-result-row__price">' + formatMoney(p.price) + '</span>' +
            '</a>'
          );
        }).join('');
      })
      .catch(function () { /* fail silently; native search submit still works */ });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var drawerItems = drawer ? drawer.querySelector('[data-cart-items]') : null;
  var drawerFooter = drawer ? drawer.querySelector('[data-cart-footer]') : null;
  var drawerEmpty = drawer ? drawer.querySelector('[data-cart-empty]') : null;
  var lineTemplate = document.getElementById('CartLineTemplate');
  var cartOpen = false;

  function openDrawer() {
    if (!drawer || cartType !== 'drawer') return;
    drawer.hidden = false; cartOpen = true; showBackdrop();
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true; cartOpen = false; hideBackdrop();
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeDrawer();
    var opener = e.target.closest('[data-cart-open]');
    if (opener) {
      if (cartType === 'drawer') {
        e.preventDefault();
        openDrawer();
      }
      // cartType === 'page': let the link navigate to /cart
    }
    var checkoutBtn = e.target.closest('[data-cart-checkout]');
    if (checkoutBtn) window.location.href = '/checkout';
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMobileMenu(); closeSearch(); }
  });

  function updateCountBubbles(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderFreeShipping(totalPrice) {
    var wrap = drawer ? drawer.querySelector('[data-free-shipping]') : null;
    if (!wrap || !freeShippingThreshold) return;
    var text = wrap.querySelector('[data-free-shipping-text]');
    var fill = wrap.querySelector('[data-free-shipping-fill]');
    var pct = Math.min(100, Math.round((totalPrice / freeShippingThreshold) * 100));
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (totalPrice >= freeShippingThreshold) {
        text.textContent = wrap.dataset.msgUnlocked;
      } else {
        text.textContent = wrap.dataset.msgRemaining.replace('{{ amount }}', formatMoney(freeShippingThreshold - totalPrice));
      }
    }
  }

  function renderCart(cart) {
    if (!drawer) return;
    updateCountBubbles(cart.item_count);

    if (!cart.items.length) {
      if (drawerItems) drawerItems.innerHTML = '';
      if (drawerEmpty) drawerEmpty.hidden = false;
      if (drawerFooter) drawerFooter.hidden = true;
      renderFreeShipping(0);
      return;
    }
    if (drawerEmpty) drawerEmpty.hidden = true;
    if (drawerFooter) drawerFooter.hidden = false;

    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    renderFreeShipping(cart.total_price);

    if (!drawerItems || !lineTemplate) return;
    drawerItems.innerHTML = '';
    cart.items.forEach(function (item) {
      var node = lineTemplate.content.cloneNode(true);
      var line = node.querySelector('.cart-line');
      line.dataset.lineKey = item.key;
      var media = node.querySelector('.cart-line__media');
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1');
        img.alt = item.title;
        img.loading = 'lazy';
        media.appendChild(img);
      }
      node.querySelector('.cart-line__title').textContent = item.product_title || item.title;
      var variantEl = node.querySelector('.cart-line__variant');
      if (item.variant_title) variantEl.textContent = item.variant_title;
      else variantEl.remove();
      var qtyInput = node.querySelector('[data-qty-input]');
      qtyInput.value = item.quantity;
      qtyInput.dataset.lineKey = item.key;
      node.querySelector('.cart-line__price').textContent = formatMoney(item.line_price);
      node.querySelector('[data-line-remove]').dataset.lineKey = item.key;
      drawerItems.appendChild(node);
    });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  // Drawer line qty changes + removes
  if (drawer) {
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input || !input.dataset.lineKey) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty)) return;
      changeLine(input.dataset.lineKey, qty);
    });
    drawer.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (rm && rm.dataset.lineKey) changeLine(rm.dataset.lineKey, 0);
    });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function addToCart(id, qty) {
    qty = qty || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function afterAdd() {
    if (cartType === 'drawer') {
      openDrawer();
    } else {
      window.location.href = '/cart';
    }
  }

  // Quick-add buttons (product cards, drawer upsell)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var original = btn.innerHTML;
    btn.disabled = true;
    addToCart(btn.dataset.quickAdd, 1)
      .then(function () { btn.disabled = false; btn.innerHTML = original; afterAdd(); })
      .catch(function () { btn.disabled = false; btn.innerHTML = original; });
  });

  /* ---------- Variant pickers (product page + buy box) ---------- */
  document.querySelectorAll('[data-product-form-root]').forEach(function (root) {
    var variantInput = root.querySelector('[data-variant-id]');
    var variantJsonEl = root.querySelector('[data-variant-json]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    if (!variantInput || !variantJsonEl) return;

    var variants = [];
    try { variants = JSON.parse(variantJsonEl.textContent); } catch (err) {}

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var active = fs.querySelector('[data-option-value-btn].option-pill--active');
        opts.push(active ? active.dataset.optionValueBtn : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (opt, i) { return opt === v['option' + (i + 1)]; });
      });
    }

    function syncUI() {
      var variant = findVariant(currentOptions());
      var priceEls = root.querySelectorAll('[data-price-display], [data-variant-price], [data-product-price] .price__current');
      if (variant) {
        variantInput.value = variant.id;
        priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
        if (addBtn) {
          addBtn.disabled = !variant.available;
          var label = addBtn.querySelector('[data-add-to-cart-text]');
          if (label) label.textContent = variant.available ? (addBtn.dataset.addLabel || 'Add to cart') + ' — ' + formatMoney(variant.price) : (addBtn.dataset.soldOut || 'Sold out');
        }
        var priceWrap = root.querySelector('[data-product-price] .price');
        if (priceWrap) {
          var compare = priceWrap.querySelector('.price__compare');
          var onSale = variant.compare_at_price > variant.price;
          priceWrap.classList.toggle('price--on-sale', onSale);
          if (onSale && !compare) {
            compare = document.createElement('s');
            compare.className = 'price__compare';
            priceWrap.prepend(compare);
          }
          if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
        }
        var stickyPrice = document.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        var stickyAdd = document.querySelector('[data-sticky-add]');
        if (stickyAdd) stickyAdd.disabled = !variant.available;
      } else {
        variantInput.value = '';
        if (addBtn) {
          addBtn.disabled = true;
          var unavailableLabel = addBtn.querySelector('[data-add-to-cart-text]');
          if (unavailableLabel) unavailableLabel.textContent = 'Unavailable';
        }
        var unavailableSticky = document.querySelector('[data-sticky-add]');
        if (unavailableSticky) unavailableSticky.disabled = true;
      }
    }

    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-option-value-btn]');
      if (pill) {
        var fs = pill.closest('[data-option-index]');
        fs.querySelectorAll('[data-option-value-btn]').forEach(function (b) {
          b.classList.remove('option-pill--active');
          b.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('option-pill--active');
        pill.setAttribute('aria-pressed', 'true');
        var legendVal = fs.querySelector('[data-option-value]');
        if (legendVal) legendVal.textContent = pill.dataset.optionValueBtn;
        syncUI();
        return;
      }
      // AJAX add to cart (buy box / any data-add-to-cart button inside the root)
      var add = e.target.closest('[data-add-to-cart]');
      if (add && !add.disabled && add.type !== 'submit') {
        e.preventDefault();
        var qtyInput = root.querySelector('[data-qty-input]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        add.disabled = true;
        addToCart(variantInput.value, qty)
          .then(function () { add.disabled = false; afterAdd(); })
          .catch(function () { add.disabled = false; });
      }
    });

    // Native product form submit (main product page): intercept for drawer, allow for page type
    var form = root.querySelector('form[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (cartType !== 'drawer') return; // let it post to /cart
        e.preventDefault();
        var qtyInput = form.querySelector('[data-qty-input]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        addToCart(variantInput.value, qty).then(afterAdd).catch(function () {
          form.submit(); // fallback to native post
        });
      });
    }

    syncUI();
  });

  /* ---------- Sticky add-to-cart bar ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var buyRow = document.querySelector('[data-product-form-root] .product__buy-row');
  if (stickyBar && buyRow) {
    var stickyAdd = stickyBar.querySelector('[data-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var root = document.querySelector('[data-product-form-root]');
        var mainAdd = root ? root.querySelector('form [data-add-to-cart]') : null;
        if (mainAdd) mainAdd.click();
        else buyRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    var onScroll = function () {
      var past = buyRow.getBoundingClientRect().bottom < 0;
      stickyBar.classList.toggle('sticky-atc--visible', past);
      stickyBar.hidden = false;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var mainMedia = section.querySelector('[data-main-media]');
    var mainImg = mainMedia ? mainMedia.querySelector('img') : null;
    section.addEventListener('click', function (e) {
      var step = e.target.closest('[data-gallery-step]');
      if (step) {
        var thumbs = Array.from(section.querySelectorAll('[data-thumb]'));
        var current = thumbs.findIndex(function (item) { return item.classList.contains('product__thumb--active'); });
        if (thumbs.length) thumbs[(current + Number(step.dataset.galleryStep) + thumbs.length) % thumbs.length].click();
        return;
      }
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb || !mainImg || !thumb.dataset.full) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = thumb.dataset.full;
      mainImg.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : mainImg.alt;
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.remove('product__thumb--active');
        t.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('product__thumb--active');
      thumb.setAttribute('aria-selected', 'true');
    });
  });

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('product-recommendations').forEach(function (el) {
    var url = el.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('product-recommendations');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- Refresh drawer count on load ---------- */
  refreshCartCountOnly();
  function refreshCartCountOnly() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCountBubbles(cart.item_count); })
      .catch(function () {});
  }
})();
